import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuthInfo, isNoSessionError, isNotAuthorizedError, logOut } from '../../api/auth';

const readSession = async (rejectWithValue: (value: string) => any) => {
    try {
        return await getAuthInfo({ forceRefresh: true });
    } catch (error: any) {
        // Refresh token revoked/expired, or no Amplify user any more: end the session so the login form shows.
        if (isNotAuthorizedError(error) || isNoSessionError(error)) return logOut();
        return rejectWithValue(error?.message ?? 'Auth error');
    }
};

/** Page load / sign-in: reads the session and refreshes the tokens so `cognito:groups` is current. */
export const getAuthenticatedUser = createAsyncThunk(
    'auth/getAuthenticatedUser',
    (_, { rejectWithValue }) => readSession(rejectWithValue)
);

/** Background re-check (SessionKeeper): same as above without putting the app into the loading state. */
export const refreshAuthenticatedUser = createAsyncThunk(
    'auth/refreshAuthenticatedUser',
    (_, { rejectWithValue }) => readSession(rejectWithValue)
);

export const logOutUser = createAsyncThunk('auth/logOutUser', () => logOut());
